/** Libellés FR/EN — Titres & Reconnaissances Phase 1 */

export const TITLE_TYPES = {
  enseignement: { fr: "Enseignement", en: "Teaching" },
  reconnaissance: { fr: "Reconnaissance", en: "Recognition" },
  responsabilite: { fr: "Responsabilité", en: "Responsibility" },
  honneur: { fr: "Honneur", en: "Honour" },
};

export const TITLE_STATUSES = {
  demo: { fr: "Démo", en: "Demo" },
  a_valider: { fr: "À valider", en: "To validate" },
  futur: { fr: "Futur", en: "Future" },
};

export const APPLICATION_STATUSES = {
  brouillon: { fr: "Brouillon", en: "Draft" },
  soumis: { fr: "Soumis", en: "Submitted" },
  en_revision: { fr: "En révision", en: "Under review" },
  documents_manquants: { fr: "Documents manquants", en: "Missing documents" },
  recommande: { fr: "Recommandé", en: "Recommended" },
  approuve: { fr: "Approuvé", en: "Approved" },
  refuse: { fr: "Refusé", en: "Refused" },
  titre_attribue: { fr: "Titre attribué", en: "Title granted" },
  archive: { fr: "Archivé", en: "Archived" },
};

export const REGISTER_STATUSES = {
  demo: { fr: "Démo", en: "Demo" },
  a_confirmer: { fr: "À confirmer", en: "To confirm" },
  officiel_plus_tard: { fr: "Officiel plus tard", en: "Official later" },
};

export const AUTHORITY_STATUSES = {
  en_attente_documents: { fr: "En attente documents", en: "Awaiting documents" },
  a_valider: { fr: "À valider", en: "To validate" },
  valide_demo: { fr: "Validé démo", en: "Demo validated" },
};

export const CERTIFICAT_STATUSES = {
  futur_pdf: { fr: "Certificat PDF futur", en: "Future PDF certificate" },
  non_emis: { fr: "Non émis", en: "Not issued" },
  demo: { fr: "Démo", en: "Demo" },
};

/**
 * @param {Record<string, {fr: string, en: string}>} map
 * @param {string} key
 * @param {'fr'|'en'} locale
 */
export function titleLabel(map, key, locale) {
  const entry = map[key];
  if (!entry) return key;
  return locale === "en" ? entry.en : entry.fr;
}
